<h1>
<i class="fa fa-{{icon}} confirm-icon" aria-hidden="true" *ngIf="icon"></i>
    {{title}}
  </h1>
  
  <div mat-dialog-content>
    <div [innerHTML]="message"></div>
  </div>
  
  <div class="mat-dialog-actions">
    <button mat-raised-button color="primary" (click)="onConfirm()" [ngClass]="yesBtnClass" class="footer-button">Yes</button>
    <button mat-raised-button (click)="onDismiss()" [ngClass]="noBtnClass" class="footer-button">No</button>

  </div>